import styled from 'styled-components';

import theme from '../../../../styles/defaultTheme';

export const ShowLength = styled.h1`
  font-size: ${theme.font.size15};
  display: flex;
  justify-content: flex-end;
  margin-top: -15px;
`;
